import Vercel from '@gonfalon/img/icons/vercel.svg';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Tag, TagGroup, TagList, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import styles from './VercelEnvironmentIndicator.module.css';

interface Props {
  variant?: 'tag' | 'icon';
}

function VercelIcon() {
  return (
    <span className={styles.icon}>
      <Vercel width={12} height={12} />
    </span>
  );
}

export function VercelEnvironmentIndicator({ variant = 'icon' }: Props) {
  if (variant === 'icon') {
    return <VercelIcon />;
  } else if (variant === 'tag') {
    return (
      <TooltipTrigger>
        <TagGroup aria-label="platform">
          <TagList>
            <Tag
              size="small"
              variant="default"
              className={styles.tag}
              textValue={msg('environments.vercelIndicator.label')}
            >
              <VercelIcon />
              {msg('environments.vercelIndicator.label')}
            </Tag>
          </TagList>
        </TagGroup>
        <Tooltip>
          <Message id="environments.vercelIndicator.tooltip" />
        </Tooltip>
      </TooltipTrigger>
    );
  }
}
